var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Top'),_c('router-view',{staticStyle:{"min-height":"100%"}}),_c('PopUpPrompt',{ref:"PopUpPrompt"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }